var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "k-main", attrs: { role: "main" } },
    [
      _vm._t(
        "title",
        function () {
          return [
            _c("h1", {
              staticClass: "title",
              domProps: { innerHTML: _vm._s(_vm.title) },
            }),
          ]
        },
        { title: _vm.title }
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }